export const ADD_USERS_IDS = "ADD_USERS_IDS"
export const ON_ADD_USERS_IDS = "ON_ADD_USERS_IDS"

export const GET_USERS_IDS = "GET_USERS_IDS"
export const ON_GET_USERS_IDS = "ON_GET_USERS_IDS"

export const API_ERROR = "API_ERROR_USERS_IDS"
export const API_SUCCESS = "API_SUCCESS_USERS_IDS"
